module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container modal-sm"
  }, [_c('div', {
    staticClass: "modal-body text-center"
  }, [_c('p', {
    staticClass: "lead"
  }, [_vm._v("Loading\n          "), _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-lg fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d955e9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/LoadingModal.vue
// module id = 630
// module chunks = 0